
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import Slider from "react-slick";
import { BaseUrl } from '../../helper/BaseUrl';
import { DateConvert } from '../../helper/DateConvert';

export default function NewsRelated({ extraClass = "", initialData }) {
    const [allData, setAllData] = useState(initialData || []);
    const { slug } = useParams();
    const fetcher = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/medias`, {
                method: 'GET',
            });
            const result = await response.json();
            if (result.medias === false) {
                throw new Error(`API error: ${result.message}`);
            }
            setAllData(result.medias);
        } catch (error) {
            console.error('Fetch error:', error.message);
        }
    };


    const filterData = allData?.filter((item) => item.slug !== slug);

    useEffect(() => {
        fetcher();
    }, [])




    const settingskey = {
        autoplay: true,
        speed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: (
            <button className="slick-arrow slick-prev" aria-label="Previous Slide">
                <i className="fa-solid fa-arrow-left"></i>
            </button>
        ),

        nextArrow: (
            <button className="slick-arrow slick-next" aria-label="Next Slide">
                <i className="fa-solid fa-arrow-right"></i>
            </button>
        ),
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },

            {
                breakpoint: 99999,
                settings: "unslick",
            },
        ],
    };


    if (!allData) {
        return <div style={{ height: "100vh", width: "100%" }}></div>;
    }


    return (
        <>
            <section className={`blogpage news-card ${extraClass}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="related-text center-heading">
                                <h3 className="heading">More related Articles</h3>
                            </div>
                        </div>
                    </div>
                    <div className="other-projects-wrap">
                        <Slider {...settingskey} className="other-detail-slides">
                            {filterData.slice(-3).map((data, index) => (
                                <div className="other-detail-card" key={index}>
                                    <Link to={`/news/${data.slug}`} className="blogpost-box">
                                        <div className='blogpost-image'>
                                            <img src={data?.thumbnail ? `${BaseUrl}${data.thumbnail}` : undefined} className="img-responsive" alt={data?.alt_thumbnail} loading="lazy" />
                                        </div>
                                        <div className='blogpost-detail'>
                                            <div className="category">{DateConvert(data?.date)}</div>
                                            <span>{data?.title}</span>
                                            <div className='arrow-butn'>Learn More <img src="/assets/images/arrow.webp" loading="lazy" alt="arrow" /></div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className='text-center'>
                                <Link to={"/news"} className="default-btn"><span>View More</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


